import React, { useCallback, useEffect, useState } from "react";
import { Link } from "../../utils/customLink";
import { SelectMenu } from "../shared/selectMenu";
import { useBreakpoint } from "../../hooks";
import { VIPriceDurationsTable } from "./viPriceDurationsTable";
import { VIPriceSubCourseTable } from "./viPriceSubCourseTable";
import { VIPriceAccordion } from "./viPriceAccordion";
import MoutainIllustration from "../../images/illustrations/Mountain_illustration.inline.svg";
import DragonFlyIllustration from "../../images/illustrations/Dragonfly.inline.svg";

export const VIPrices = ({
  subCourses,
  courses,
  vi40HoursDurationPrice,
  vi80HoursDurationPrice,
  vi120HoursDurationPrice,
  viTime5,
  viTime10,
  viDatesAndCostsTitle,
  currencySymbol,
  applyLink
}) => {
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState(null);
  const durations = [
    {
      value: "40"
    },
    {
      value: "80"
    },
    {
      value: "120"
    }
  ];

  const breakpoint = useBreakpoint();
  useEffect(() => {
    if (breakpoint === "xs") {
      const initDuration = durations[0]?.value;
      setSelectedCourse(
        courses?.filter(
          (course) => parseInt(course.viDuration) === parseInt(initDuration)
        )
      );
      setSelectedDuration(parseInt(initDuration));
    } else {
      setSelectedCourse(null);
    }
  }, [breakpoint, courses]);

  const handleMenu = useCallback(
    (duration) => {
      setSelectedDuration(duration);
      setSelectedCourse(
        courses?.filter(
          (course) => parseInt(course.viDuration) === parseInt(duration)
        )
      );
    },
    [courses]
  );

  const menuOptions = durations.map((duration, index) => {
    return {
      value: duration.value,
      label: duration.value + " Hours",
      id: parseInt(duration.value)
    };
  });

  return (
    <>
      <section className="relative flex flex-col md:flex-row items-center justify-center bg-white dark:bg-gray-dark">
        <div className="hidden md:block absolute left-0 top-0 overflow-hidden w-[46vw] dark:w-auto">
          <MoutainIllustration className="dark:hidden relative -left-[13vw] -top-[6vw] w-full h-full -scale-x-100 xl:w-2/5" />
          <DragonFlyIllustration className="hidden dark:block relative -left-[10vw] -top-[8vh]" />
        </div>
        <div className="md:absolute md:-translate-y-1/2 top-0 flex flex-col justify-center w-11/12 md:w-2/3 mx-auto py-2 h-24 bg-transparent md:bg-yellow-standard md:dark:bg-gray-standard">
          <h1
            className="text-title text-left font-normal text-white dark:font-light md:text-center md:text-[38px]"
            dangerouslySetInnerHTML={{
              __html: viDatesAndCostsTitle
            }}
          />
        </div>
        <div className="relative w-11/12 md:gvi-container pb-14 md:pb-28 md:pt-36 text-center">
          <div className="mb-5 md:hidden uppercase text-left h7">
            <SelectMenu
              className="bg-yellow-standard dark:bg-gray-standard rounded-xs"
              options={menuOptions}
              placeholder="Select a duration"
              setOpenTab={handleMenu}
            />
          </div>
          <VIPriceDurationsTable
            key={"vi-price-duration-table"}
            courses={courses}
            selectedCourse={selectedCourse}
            selectedDuration={selectedDuration}
            vi40HoursDurationPrice={vi40HoursDurationPrice}
            vi80HoursDurationPrice={vi80HoursDurationPrice}
            vi120HoursDurationPrice={vi120HoursDurationPrice}
            viTime5={viTime5}
            viTime10={viTime10}
            currencySymbol={currencySymbol}
          />
          <VIPriceAccordion
            className="mt-12 mb-6 cursor-pointer"
            key={"vi-price-accordion"}
          >
            <VIPriceSubCourseTable
              courses={courses}
              subCourses={subCourses}
              selectedCourse={selectedCourse}
            />
          </VIPriceAccordion>
          <Link
            className="submit-button group flex md:inline-flex justify-center items-center px-20 py-2 mt-7"
            to={applyLink}
          >
            <p className="pr-2 font-bold">Apply</p>
          </Link>
        </div>
      </section>
    </>
  );
};
